import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, FormBuilder} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { ColDef, GridApi } from 'ag-grid-community';
import { ClaveValorModel } from 'src/app/model/datos-maestros/claveValorModel';

@Component({
  selector: 'app-tipo-planificacion',
  templateUrl: './tipo-planificacion.component.html',
  styleUrls: ['./tipo-planificacion.component.css']
})

export class TipoPlanificacionComponent implements OnInit {
 
  public DAT_TITULOS    = diccionarios.titulos.tipos;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  //Variables para el Grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public defaultColDef  : ColDef;
  public gridApi        : GridApi;
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridColumnApi  : any;
  
  public textoBuscar    : string;

  // Variables funcionales
  public listCatalogos;
  public cmbxEstados    : ClaveValorModel[] = [];
  public usarioActual   : any;
  public fechaHoraInicio: string;
  
  //Formularios
  public formulario: FormGroup;
  
  constructor(
    private utilServices    : UtilsService,
    private trackingConfigAPI: TrackingConfiguracionService,
    private _catalogos      : CatalogosLogisticaService,
    private fbServices      : FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formulario = this.fbServices.group({
      idTipo              : [''],
      nombre              : ['', [Validators.required]],
      tipoEscenario       : ['', [Validators.required]],
      prioridadKanban     : ['', [Validators.required]],
      georeferencia       : [false],
      georeferenciaTiempo : [''],
      georeferenciaRango  : [''],

      generaTicketGarita  : [false],
      generaTicketBalanza : [false],

      requiereOrden       : [false],
      requiereBuque       : [false],
      requiereOrigen      : [false],
      requiereTanquero    : [false],
      requiereArea        : [false],
      requiereCheck       : [true],
      
      estado              : ['', Validators.required],
      creadoPor           : ['', Validators.required],
      modificadoPor       : [''],
      creado    : [],
      modificado: [],
    });

    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.cargarGridcomponent();
    this.inicializar();
  }

  get escenario() {
    return this.formulario.get('tipoEscenario');
  }
  
  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [      
      { field: 'idTipo' , sort:"desc"},
      { field: 'nombre' },
      { field: 'tipoEscenario' },
      { field: 'estado', cellRenderer: (data) => { return data.value ? 'Activo' : 'Inactiva' }},
      { field: 'prioridadKanban' },
      { field: 'generaTicketGarita',  cellRenderer: (data) => { return data.value ? 'SI' : 'NO' }},
      { field: 'generaTicketBalanza', cellRenderer: (data) => { return data.value ? 'SI' : 'NO' }},
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.editar.bind(this), label: 'Editar'} },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.delete.bind(this), label: 'Eliminar'} }
    ];

    this.defaultColDef = this._catalogos.getDefaultColDef();
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  inicializar(){
    this.cmbxEstados  = this._catalogos.catalogoEstadoLogico();
    this.trackingConfigAPI.getAllCatalogos().subscribe((res) => {
      if(res) this.listCatalogos = res; 
    }, (err) => { 
      console.log(err.message); 
    });

    this.listar();
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    this.formulario.reset();
    this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
    this.formulario.get('estado').setValue(1);
    this.openModal();
  }

  editar({rowData}){
    this.isCreate = false;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    console.log("registro a editar", rowData);
    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.openModal();
  }

  //Filtra las areas activas
  listar(){
    this.rowData = [];
    this.trackingConfigAPI.getAllTipos().subscribe((res) => {
      if(res) this.rowData = res.filter(e=> e.estado == true); 
    }, (err) => { 
      console.log(err.message); 
    });
  }

  /** Si el form esta en modo de creación ejecuta post caso contrario un put. 
   * Ver estado variable isCreated 
   * */
  saveForm() {
    //this.getFormValidationErrors();
    if (this.formulario.invalid) return;

    this.loading  = true;
    let mensajeP  = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    let data = this.formulario.getRawValue();
    data.modificadoPor = !this.isCreate ? this.usarioActual.login2 : data.modificadoPor ; 
    
    //Seteo de valores cuando es null
    data.generaTicketBalanza  = data.generaTicketBalanza == null ? false : data.generaTicketBalanza;
    data.generaTicketGarita   = data.generaTicketGarita == null ? false : data.generaTicketGarita;
    data.requiereTanquero     = data.requiereTanquero == null ? false : data.requiereTanquero;
    data.georeferencia  = data.georeferencia == null ? false : data.georeferencia;
    data.requiereBuque  = data.requiereBuque == null ? false : data.requiereBuque;
    data.requiereOrden  = data.requiereOrden == null ? false : data.requiereOrden;
    data.requiereOrigen = data.requiereOrigen == null ? false : data.requiereOrigen;
    data.requiereArea   = data.requiereArea == null ? false : data.requiereArea;
    data.requiereCheck  = true;

    let validaGEO = data.georeferencia && (data.georeferenciaRango <= 0 || data.georeferenciaTiempo <= 0 )
    if(validaGEO){
        this.utilServices.mensajeErrorVisto("Debe llenar todos los datos de la GeoLocalización", true, 5000);
        this.loading = false;
        return
    }
    const payload =  data;
    console.log("payload a enviar", payload);
    
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.trackingConfigAPI.saveTipos(payload) : this.trackingConfigAPI.updateTipos(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }
  
  //Borrado logico solo inactiva el registro
  delete({rowData}){
    this.loading = true;
    rowData.estado = 0;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    this.utilServices.confirmarSincronoPromesa({
        title : diccionarios.mensajes.eliminar,
        text  : this.GLOBAL_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.trackingConfigAPI.updateTipos(rowData),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  validaciones(){
    if(!this.formulario.get('georeferencia').value){
        this.formulario.get('georeferenciaRango').reset();
        this.formulario.get('georeferenciaTiempo').reset();
    }

    const require = this.formulario.get('tipoEscenario').value == 'COMPRAS' || 
    this.formulario.get('tipoEscenario').value == 'VENTA'; 
    if(require){
        this.formulario.get('requiereOrden').reset();
        this.formulario.get('requiereBuque').reset();
        this.formulario.get('requiereTanquero').reset();
        this.formulario.get('requiereOrigen').reset();
    }
  }

}

